const DISCOVERY_DOCS = 'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest';
const SCOPE = "https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/drive.metadata";
const CONFIG = {
    develop: {
        API_KEY: 'AIzaSyCr671npq4qBECSOhxY0sjBOdAggAl-CNM',
        CLIENT_ID: '606505177477-bmjfmvi5e4im1ok08b9bvv016tpn7paj.apps.googleusercontent.com',
        DISCOVERY_DOCS,
        SCOPE
    },
    staging: {
        API_KEY: 'AIzaSyCr671npq4qBECSOhxY0sjBOdAggAl-CNM',
        CLIENT_ID: '606505177477-786161gcp1amapkpahautgrolm40ugs3.apps.googleusercontent.com',
        DISCOVERY_DOCS,
        SCOPE
    },
    production: {
        API_KEY: 'AIzaSyDmcRl7TH5g74KN4b0gIT_vAY1ov5xOU2A',
        CLIENT_ID: '319390482170-2gl8tpjqistmk3tj2gt2fjrvdo1qld59.apps.googleusercontent.com',
        DISCOVERY_DOCS,
        SCOPE
    }
}

export default CONFIG;